import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TextInput, useMuiController } from "@sinch/components/index";

export const CreateIntervalNameField: FC = () => {
  const { t } = useTranslation();
  const { field } = useMuiController({ name: "name" });
  return <TextInput {...field} fullWidth label={t("RateUnit.intervalName")} />;
};
